import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import { LoginLayout } from 'components';

const ForgotPasswordSuccess = ({ t }) => (
  <LoginLayout
    title={t('login.forgotPassword.success.title')}
    description={t('login.forgotPassword.success.description')}
  >
    <Link className="button button--full" to="/login-email">
      {t('login.forgotPassword.success.backToLogin')}
    </Link>
  </LoginLayout>
);

ForgotPasswordSuccess.propTypes = {
  t: PropTypes.func.isRequired
};

export default translate()(ForgotPasswordSuccess);



// WEBPACK FOOTER //
// ./src/components/ForgotPasswordSuccess/ForgotPasswordSuccess.js